module.exports = __webpack_public_path__ + "e6ea59db9fc70a5ee0ac80f664f0943c.MP3";